<div class="c-survey__section survey-choices">
  <h2 class="c-survey__question">{{engagementCardObj.Title | translate}}</h2>
  <span>
    {{engagementCardObj.Description | translate}}
  </span>
</div>
